var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M224,6C100.25,6,0,106.12,0,229.75c0,97.77,62.71,180.88,150.05,211.4,11.76,3,10-5.4,10-11.11V391.27c-67.92,8-70.67-37-75.22-44.49-9.21-15.71-31-19.71-24.48-27.21,15.47-8,31.23,2,49.5,29,13.21,19.56,39,16.26,52.05,13a63.21,63.21,0,0,1,17.37-30.42c-70.37-12.6-99.7-55.53-99.7-106.57,0-24.77,8.16-47.53,24.17-65.89-10.21-30.28,1-56.19,2.46-60,29.08-2.6,59.31,20.82,61.66,22.67,16.52-4.45,35.38-6.81,56.51-6.81s40.14,2.46,56.8,7c5.66-4.3,33.69-24.42,60.71-22,1.45,3.86,12.37,29.17,2.76,59,16.21,18.42,24.47,41.38,24.47,66.2,0,51.14-29.53,94.12-100.1,106.52A63.81,63.81,0,0,1,288,376.76V433c.4,4.51,0,9,7.51,9C384.19,412.13,448,328.42,448,229.8,448,106.12,347.7,6,224,6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.8dc434ca.svg";
export { ForwardRef as ReactComponent };